<template>
  <div>

    <b-card no-body>
      <b-card-header>
        <div class="align-items-center row">
          <div class="col">
            <h3 class="card-title mb-0">{{ $t("Fotoğraf Çekimi Tarihleri") }}</h3>
          </div>
          <div class="col">
            <b-form-group class="mb-0">
              <b-form-select v-model="company" v-if="getType=='all'" :options="companies" @change="cPage=1; refreshTable();"/>
            </b-form-group>
          </div>
          <div class="col text-right">
            <!--              <b-button :to="{name: 'create-client'}" variant="primary">+ Yeni Ekle</b-button>-->
          </div>
        </div>
      </b-card-header>

      <b-table responsive ref="table" class="align-items-center" thead-class="thead-light" :fields="fields" :items="loadData"
               show-empty>

        <template v-slot:table-busy>
          <div style="width: 100%; text-align:center;">
            <b-spinner label="Spinning"></b-spinner>
          </div>
        </template>

        <template v-slot:empty>
          <b-alert variant="warning" show>{{ $t("Henüz hiç randevu oluşturmamışsınız, hemen yeni bir tane ekleyin") }}!</b-alert>
        </template>


        <template v-slot:cell(photo_date)="data">
          {{ moment(data.item.photo_date).format('DD/MM/YYYY') }}
        </template>

        <template v-slot:cell(actions)="data">
          {{ data.item.accountingss[0].services.map(s=>s.service.name).join(',') }}
        </template>




      </b-table>

      <div class="w-100 d-flex align-items-center justify-content-center mt-2 mb-3" v-if="pagination.totalRows > 14">
        <b-pagination v-model="pagination.currentPage" :total-rows="pagination.totalRows"
                      :per-page="pagination.perPage"/>
      </div>
    </b-card>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import request from "../request";
import moment from "moment";
import {required} from "vuelidate/lib/validators";

export default {
  name: 'PhotoDatesCard',
  props:{
    client:null
  },
  computed: {
    ...mapGetters(['companies']),
    getType() {
      return this.$route.params.type
    },
    fields() {
      let fields = [
        {key: 'photo_date', label: 'Tarih'},
        {key: 'actions', label: 'Ürünler'},
      ]
      //
      // if (this.getType == 'all')
      //   fields.push({'company': 'Bayii'})
      // else
      //   fields.push(
      //       {key: 'actions', label: '', tdClass: 'text-right'})
      //
      // if(this.client!=null){
      //
      //   fields=fields.filter(f=>f.key!='client_name');
      //   fields=fields.filter(f=>f.key!='client_gsm');
      // }

      return fields;

    }
  },
  data() {
    return {
      text:'',
      company: null,
      loading: true,
      buttonLoading: false,
      pagination: {
        currentPage: 1,
        totalRows: 1,
        perPage: 15,
      },
      calendarModal: {
        client: {},
        employee: {label: "Tüm Çalışanlar", value: "all"},
        services: [],
        description: '',
        start_date: null,
        start_time: null,
        end_date: null,
        end_time: null,
        sendSMS: false,
      },
      serviceModal: {
        name: "",
        price: 0,
      },
      clientModal: {
        full_name: "",
        gsm: "",
        email: ""
      },
      services: [],
      clients: [],
      employees: [],
      reminder: {
        id: '',
        text: '',
      },
    }
  },
  mounted(){
    this.getDefinitions().then(res=>{
      // console.log()
      let data=res.data.data.find(item=>item.slug=='kuafor-randevu-hatirlat')
      this.text=data.content
    })
  },
  methods: {
    ...mapActions([
      'getCoiffeurAppointments',
      'createCoiffeurAppointment',
      'deleteCoiffeurAppointment',
      'createClientVSelect',
      'appointmentReminder',
      'setPassiveCoiffeur',
      'getDefinitions',
    ]),
    ...mapMutations(['setSMSBalance']),

    refreshTable() {
      this.$refs.table.refresh();
    },

    moment(d) {
      return moment(d);
    },
    loadData() {
      this.loading = true
      let payloads = {}
      payloads.employee = this.employee
      if (this.getType == 'all') {

        payloads.getType = 'all'
        if (this.company != null)
          payloads.company = this.company
      }


      if (this.client != null)
        payloads.client_id = this.client

      return request.get('processes/photodates?client_id='+this.client).then(res=>{
        return res.data.data
      }).catch(e=>{

      })
    }
  },
  validations: {
    calendarModal: {
      client: {
        value: {required}
      },
      start_date: {required},
      start_time: {required},
      end_date: {required},
      end_time: {required},
    }
  },
}
</script>

<style scoped>

</style>